/**
 * @file PlatformAdminRoute.js
 * @description Ruta protegida que sólo permite el acceso a usuarios con el
 * flag `platformAdmin` (IT-700, panel trimergy-admin integrado). Si el usuario
 * no está autenticado se le redirige al login; si no es admin de plataforma,
 * a su área personal.
 *
 * Es deliberadamente independiente de AdminRoute (role === 'admin'): el
 * acceso al panel de administración usa un atributo propio de la colección
 * de usuarios y no participa del ciclo de roles (payg/premium).
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import icoHourglass from '../../assets/images/icons/ico_hourglass.svg';

const PlatformAdminRoute = ({ children, redirectTo = '/mi-area' }) => {
  const { isAuthenticated, isPlatformAdmin, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    if (!isPlatformAdmin) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, isPlatformAdmin, isLoading, navigate, redirectTo]);

  if (isLoading) {
    return (
      <div className="loading" style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>
          <img
            src={icoHourglass}
            alt=""
            style={{ width: '24px', height: '24px', verticalAlign: 'middle', marginRight: '6px' }}
          />{' '}
          Cargando...
        </h2>
        <p>Verificando permisos...</p>
      </div>
    );
  }

  if (!isAuthenticated || !isPlatformAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default PlatformAdminRoute;
